import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import logo from "../assets/EditedPng.png";
import { useLocation, useNavigate } from 'react-router-dom';

export default function Appbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (location.state?.section) {
  //     const target = location.state.section;
  //     setTimeout(() => {
  //       const el = document.getElementById(target);
  //       el?.scrollIntoView({ behavior: "smooth" });
  //     }, 300);
  //     navigate(location.pathname, { replace: true, state: {} });
  //   }

  //   const handleScroll = () => {
  //     const scrollPosition = window.scrollY + 250;
  //     const homeSection = document.getElementById("home");
  //     if (homeSection) {
  //       const homeBottom = homeSection.offsetTop + homeSection.offsetHeight;
  //       setIsScrolled(window.scrollY > homeBottom - 200);
  //     }

  //     const sections = [
  //       { id: "home", element: document.getElementById("home") },
  //       { id: "about", element: document.getElementById("about") },
  //       { id: "projects", element: document.getElementById("projects") },
  //       { id: "careers", element: document.getElementById("careers") },
  //       { id: "contact", element: document.getElementById("contact") }
  //     ];

  //     for (let i = sections.length - 1; i >= 0; i--) {
  //       const section = sections[i];
  //       if (section.element) {
  //         const sectionTop = section.element.offsetTop;
  //         if (scrollPosition >= sectionTop) {
  //           setActiveSection(section.id);
  //           break;
  //         }
  //       }
  //     }
  //   };

  //   setTimeout(handleScroll, 100);
  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [location, navigate]);

  useEffect(() => {
  if (location.state?.section) {
    const target = location.state.section;
    setTimeout(() => {
      const el = document.getElementById(target);
      el?.scrollIntoView({ behavior: "smooth" });
    }, 300);
    navigate(location.pathname, { replace: true, state: {} });
  }

  const handleScroll = () => {
    const scrollPosition = window.scrollY + 250;

    // -------- SCROLL HEADER ACTIVATION --------
    const homeSection = document.getElementById("home");
    if (homeSection) {
      const homeTop = homeSection.offsetTop;

      // Activate header when scrolling a little inside home section
      setIsScrolled(window.scrollY > homeTop + 20);
    }

    // -------- ACTIVE SECTION HANDLING --------
    const sections = [
      { id: "home", element: document.getElementById("home") },
      { id: "about", element: document.getElementById("about") },
      { id: "projects", element: document.getElementById("projects") },
      { id: "careers", element: document.getElementById("careers") },
      { id: "contact", element: document.getElementById("contact") }
    ];

    for (let i = sections.length - 1; i >= 0; i--) {
      const section = sections[i];
      if (section.element) {
        const sectionTop = section.element.offsetTop;
        if (scrollPosition >= sectionTop) {
          setActiveSection(section.id);
          break;
        }
      }
    }
  };

  setTimeout(handleScroll, 100);
  window.addEventListener("scroll", handleScroll, { passive: true });

  return () => window.removeEventListener("scroll", handleScroll);
}, [location, navigate]);

  const handleNavClick = (section) => {
    setActiveSection(section);
    setMenuOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { section: section } });
      return;
    }
    document
      .getElementById(section)
      ?.scrollIntoView({ behavior: "smooth" });
  };

  const navItems = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "projects", label: "Projects" },
    { id: "careers", label: "Career" },
    { id: "contact", label: "Contact" }
  ];

  return (
    <motion.header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled
          ? 'bg-primary-dark/95 backdrop-blur-md  border-white/10 shadow-lg'
          : 'bg-transparent'
        }`}
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo and Brand */}
          <motion.div
            className="flex items-center gap-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.1 }}
          >
            <div className={`bg-white/10 backdrop-blur-sm rounded-lg p-2 border border-white/10 ${isScrolled ? 'bg-white/90 backdrop-blur-sm  border-white/10 shadow-lg' : 'bg-transparent'}`}>
              <img
                src={logo}
                alt="Nest Constructions Logo"
                className="h-10 w-auto"
              />
            </div>
            <div className="hidden md:flex flex-col">
              <span className="text-secondary text-xs font-heading font-medium tracking-widest">KERALA</span>
              <span className="text-white text-sm font-heading font-semibold tracking-wide">NEST CONSTRUCTIONS</span>
            </div>
          </motion.div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item, index) => (
              <motion.a
                key={item.id}
                href={`#${item.id}`}
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${activeSection === item.id
                    ? 'text-secondary bg-secondary/10'
                    : 'text-white hover:text-secondary hover:bg-white/5'
                  }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.id);
                }}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.1 + index * 0.05 }}
              >
                {item.label}
              </motion.a>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden relative w-10 h-10 flex items-center justify-center text-white"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <div className="w-6 flex flex-col gap-1.5">
              <span className={`h-0.5 bg-white transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
              <span className={`h-0.5 bg-white transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
              <span className={`h-0.5 bg-white transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="md:hidden bg-primary-dark/98 backdrop-blur-md border-t border-white/10"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <nav className="container mx-auto px-4 py-4 flex flex-col gap-2">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  className={`px-4 py-3 rounded-lg font-medium transition-all ${activeSection === item.id
                      ? 'text-secondary bg-secondary/10'
                      : 'text-white hover:bg-white/5'
                    }`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.id);
                  }}
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
